import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { deleteRenderElement } from "../../Redux/Actions/FormStateActions";
import { functions } from "../IFormDesignerLayout/ApplicationAPI/applicationApi";
import { getFormJsonFromStore } from "../IFormDesignerLayout/IFormDesignerLogic";
import isEqual from "fast-deep-equal";

const useRender = (data) => {
  const controlId = data?.id;
  const dispatch = useDispatch();
  const renderElem = useSelector((state) => state?.renderElements?.get(controlId));
  const hasDeleted = useRef(false); // ✅ Prevents multiple deletes
  let updatedJSON = data;
  if(renderElem && !hasDeleted.current && !data.nonControlId) {
    updatedJSON = functions.readJson(getFormJsonFromStore(),data.id);
  }

  useEffect(() => {
    if (renderElem && !hasDeleted.current && controlId !== "dnd_backdrop") {
      console.log("inside deleterenderElement custom hook", controlId);
      dispatch(deleteRenderElement(controlId));
      hasDeleted.current = true; // ✅ Ensures delete happens only once
    }
    else{
      hasDeleted.current = false
    }
  }, [renderElem, dispatch, controlId]);

  return [renderElem, updatedJSON, isEqual(updatedJSON, data)];
};

export default useRender;
